import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 36px 0;
`

export const Title = styled.div`
  color: var(--Foreground-Neutral, #14171f);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 100% */
  text-align: justify;
  text-align-last: center;
`

export const TitleContainer = styled.div`
  max-width: 100%;
`
